import { Get } from "../../config/api";
import { useEffect, useState } from "react";
import { Col, Row, Card, Table, Pagination, Spin } from "antd";
import { useSelector } from "react-redux";
import DashbordSidebar from "../../components/DashboardSidebar";
import { BOOKING, RATES } from "../../config/constants/api";
import { useNavigate } from "react-router";
import { extractTime } from "../../config/helpers/index";
import dayjs from "dayjs";
import { AiOutlineEye } from "react-icons/ai";

const HistoryBookings = () => {
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);
  // const userData = useSelector((state) => state.user.userData);
  const [bookings, setBookings] = useState([]);
  const [latestRates, setLatestRates] = useState(null);
  const navigate = useNavigate();
  // const [latestFares, setLatestFares] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // getAllLatestFares();
    getAllLatestRates();
    getBookings();
    //eslint-disable-next-line
  }, []);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;
  // const getAllLatestFares = () => {
  //   Get(FARE.getAllLatestFares, token)
  //     .then((response) => {
  //       if (response?.status) {
  //         setLatestFares(response?.data?.latestFares);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("error", err);
  //     });
  // };
  const getHourlyRate = (serviceType, passengerCapacity) => {
    if (latestRates) {
      let rate = latestRates.find(
        (rate) =>
          rate._id.serviceType === serviceType &&
          rate._id.passengerCapacity === passengerCapacity
      );
      return rate?.rate;
    }
  };
  const getAllLatestRates = () => {
    Get(RATES.getAllLatestRates, token)
      .then((response) => {
        if (response?.status) {
          setLatestRates(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
  };

  const getBookings = async (pageNumber, pageSize) => {
    Get(BOOKING.getAllBookings, token, {
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
      status: "COMPLETED",
      chauffeur : userData?._id,
    })
      .then((response) => {
        if (response?.status) {
          setBookings(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching bookings ", err);
        setLoading(false);
      });
  };
  const columns = [
    {
      title: "S. No.	",
      dataIndex: "_id",
      key: "_id",
      width: 100,
      render: (value, item, index) => (index < 9 && "0") + (index + 1),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (item) => <span>{dayjs(item).format("M/D/YYYY")}</span>,
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (item) => <span>{extractTime(item)}</span>,
    },
    {
      title: "First Name",
      dataIndex: "user",
      key: "user",
      render: (item) => (item?.firstName ? item?.firstName : "-"),
    },
    {
      title: "Last Name",
      dataIndex: "user",
      key: "user",
      render: (item) => (item?.lastName ? item?.lastName : "-"),
    },
    {
      title: "Pk-up Address",
      dataIndex: ["pickupLocation", "address"],
      key: "address",
      render: (item) => (item?.length > 35 ? item?.slice(0, 35) + "..." : item),
    },
    {
      title: "Dr-off Address",
      dataIndex: ["dropoffLocation", "address"],
      key: "address",
      render: (item) =>
        item
          ? item?.length > 35
            ? item?.slice(0, 35) + "..."
            : item
          : "Unknown",
    },
    {
      title: "Car Type",
      dataIndex: "serviceType",
      key: "serviceType",
      render: (item) => <span>{item + " Luxury"}</span>,
    },
    {
      title: "Req Duration",
      dataIndex: "duration",
      key: "duration",
      render: (value, item) => (
        <span>{value >= 60 ? value / 60 + " hours" : value + " mins"} </span>
      ),
    },
    {
      title: "Discount",
      dataIndex: "-",
      key: "-",
      render: (item) => <span>{"00%"}</span>,
    },
    {
      title: "Rate",
      dataIndex: "",
      key: "rate",
      render: (item) => (
        <span>
          ${getHourlyRate(item?.serviceType, item?.passengerCapacity)}Hr
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "",
      key: "rate",
      render: (item) => (
        <span>
          {item?.duration < 60
            ? (
                (item?.duration *
                  getHourlyRate(item?.serviceType, item?.passengerCapacity)) /
                60
              ).toFixed(2)
            : (
                getHourlyRate(item?.serviceType, item?.passengerCapacity) *
                (item?.duration / 60)
              ).toFixed(2)}{" "}
          + per mile + overtime
        </span>
      ),
    },
    // {
    //   title: "Per mile + overtime",
    //   dataIndex: "",
    //   key: "-",
    //   render: (item) => (
    //     <span>
    //       $
    //       {getPerMileRate(item?.serviceType, item?.passengerCapacity)}
    //     </span>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (item) => (
        <>
          {item === "PENDING" ? (
            <span style={{ color: "#DD9F00" }}>{item}</span>
          ) : item === "UPCOMING" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ARRIVED" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "ACCEPTED" ? (
            <span style={{ color: "#2D308B" }}>{item}</span>
          ) : item === "COMPLETED" ? (
            <span style={{ color: "#00D640" }}>{item}</span>
          ) : (
            <span>{item}</span>
          )}
        </>
      ),
    },
    {
      title: "Booking No",
      dataIndex: "_id",
      key: "_id",
      render: (item) => <span>#{item.slice(-4)}</span>,
    },
    {
      title: "Action",
      dataIndex: "_id",
      key: "_id",
      render: (value, item, index) => (
        <AiOutlineEye
          style={{ fontSize: "18px", color: "grey", cursor: "pointer" }}
          onClick={() =>
            navigate("/ride/completedBooking/" + value, {
              state: { id: item._id },
            })
          }
        />
      ),
    },
  ];
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }

    return originalElement;
  };
  return (
    <>
      <div className="shop-page">
        <Row style={{ width: "100%", justifyContent: "center" }}>
          <Col xs={23} md={21}>
            <div className="shop-page-main">
              <Row gutter={[16, 16]}>
                <Col xs={24} md={24} lg={24} xl={24}>
                  <div className="my-account-profile">
                    <section className="side-menu-parent">
                      <DashbordSidebar />
                      <div
                        className="about-us-section"
                        style={{ justifyContent: "center" }}
                      >
                        {!loading ? (
                          <div className="bg-paren" style={{ width: "100%" }}>
                            <Card
                              className="orderDetails"
                              style={{ padding: "20px 0" }}
                            >
                              <>
                                <Row style={{ padding: 20, overflow: "auto" }}>
                                  <Table
                                    className="styledTable"
                                    dataSource={bookings}
                                    columns={columns}
                                    pagination={false}
                                  />
                                </Row>
                                <Row style={{ padding: "10px 20px" }}>
                                  <Col xs={24} md={12}>
                                    <p>{message}</p>
                                  </Col>
                                  <Col
                                    xs={24}
                                    md={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Pagination
                                      className="styledPagination"
                                      onChange={(e) => handlePageChange(e)}
                                      current={parseInt(
                                        paginationConfig.pageNumber
                                      )}
                                      pageSize={paginationConfig.limit}
                                      total={paginationConfig.totalDocs}
                                      itemRender={itemRender}
                                    />
                                  </Col>
                                </Row>
                              </>
                            </Card>
                          </div>
                        ) : (
                          <div className="bg-paren">
                            <Spin />{" "}
                          </div>
                        )}
                      </div>
                    </section>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default HistoryBookings;
